<template>
  <div class="page">
    <div class="profile-wrap">
      <template>
        <div class="user-avatar">
          <img v-if="headimgurl" :src="headimgurl" alt="" class="img" />
          <img v-else src="~@static/fundingnew/register/avatar-default.png" alt="" class="img" />
          <vue-core-image-upload style="width: 100%;height: 100%;opacity: 0;"
            :class="['button', 'file-btn', 'btn-lg', 'btn-block']" :crop="false" @imageuploaded="imageuploaded"
            @imageuploading="imageuploading" inputOfFile="file" :max-file-size="5242880" :compress="30" :max-width="200"
            input-accept="image/*" :url="uploadUrl"></vue-core-image-upload>
        </div>
        <!-- <div class="nick-name" v-if="nickname">{{nickname}}</div> -->
        <div class="nick-name" :class="isNameFocus?'center':''">
          <span v-if="!isNameFocus">{{nickname}}</span>
          <input type="text" maxlength="20" v-model="nickname" @blur="bindNicknameConfirm" v-focus="isNameFocus" v-else>
          <img class="icon-edit" src="~@static/fundingnew/profile/icon-edit.png" @click="bindEditName"
            v-if="!isNameFocus">
          <!-- <span v-if="!isNameFocus">{{nickname}}</span>
          <input class="form-control text-center" placeholder="我的昵称" v-model="username" maxlength="20" @input="bindNicknameChange" bindconfirm="bindNicknameConfirm" @blur="bindNicknameConfirm" v-else />
          <img class="icon-edit" src="~@/static/fundingnew/profile/icon-edit.png" @click="bindEditName" v-if="!isNameFocus"> -->
        </div>
        <div class="fill-cells">
          <div class="fill-cell-item" @click="handleClickItem(1)">
            <div>{{user_gender?genderName:'我的性别'}}</div>
          </div>
          <div class="fill-cell-item" @click="handleClickItem(2)">
            <div>{{user_birthday?user_birthday:'我的出生日期'}}</div>
          </div>
          <div class="fill-cell-item" @click="handleClickItem(3)">
            <div>{{user_city? user_province +'/' + user_city:'我的地区'}}</div>
          </div>
          <div class="fill-cell-item" @click="handleClickItem(4)">
            <div>{{user_hobby?hobbyName:'我的爱好'}}</div>
          </div>
          <div class="fill-cell-item" @click="handleClickItem(5)">
            <div>{{user_topic?topicName:'我感兴趣的主题'}}</div>
          </div>
        </div>
      </template>

      <div class="btn-submit">
        <button class="button pink-circle-btn icon" @click="complete">
          <div class="btn-inner">
            <div class="text">完成</div>
          </div>
        </button>
      </div>
    </div>

    <fill-modal :isShow.sync="isShow" @cancel="fillModalCancel" @confirm="fillModalConfirm" :maskClick="true">
      <div v-if="selectType == 1">
        <div class="profile-sex">
          <div class="modal-title">请选择你的性别</div>
          <div class="sex-picker">
            <div class="sex-picker-item" v-for="(item, index) in genderData" @click="handleSelectGender(item.id)"
              :key="index">
              <div class="img-inner">
                <img class="img" :src="selectGender == item.id ? item.ImgUrlActive : item.ImgUrl" alt="" />
              </div>
              <div class="sex-picker-name" :class="{ active: selectGender == item.id }">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="profile-datepicker" v-else-if="selectType == 2">
        <div class="modal-title">请选择你的出生日期</div>
        <div class="datepicker-wrap">
          <van-datetime-picker ref="birthdayPicker" type="date" v-model="currentDate" :show-toolbar="false"
            :min-date="minDate" :max-date="maxDate" :formatter="formatter" :item-height="pickerItemHeight"
            @change="handleChange" visible-item-count="3" />
        </div>
      </div>
      <div class="profile-datepicker" v-else-if="selectType == 3">
        <div class="modal-title">请选择你所在的城市</div>
        <div class="datepicker-wrap">
          <van-picker ref="cityPicker" :item-height="pickerItemHeight" :columns="columns" columns-num="2"
            visible-item-count="3" @change="handleCityChange" />
        </div>
      </div>
      <div class="profile-hobbies" v-else-if="selectType == 4">
        <div class="modal-title">请选择或输入你的爱好</div>
        <div class="circle-list">
          <div class="circle-item" :class="{active: item.checked}" v-for="(item,index) in selectHobby" :key="index"
            @click="handleSelectHobbie(index)">
            <div class="circle-item-name">{{item.name}}</div>
          </div>
        </div>
        <div class="user-input">
          <div class="user-input-inner">
            <input class="user-input-control" type="text" v-model="cusHobbyVal" placeholder="找不到？在这输入你的爱好">
          </div>
        </div>
      </div>
      <div class="profile-topic" v-else-if="selectType == 5">
        <div class="modal-title">请选择或输入你感兴趣的主题</div>
        <div class="circle-list">
          <div class="circle-item" :class="{active: item.checked}" v-for="(item,index) in selectTopic" :key="index"
            @click="handleSelectTopic(index)">
            <div class="circle-item-name">{{item.name}}</div>
          </div>
        </div>
        <div class="user-input">
          <div class="user-input-inner">
            <input class="user-input-control" type="text" v-model="cusTopicVal" placeholder="找不到？在这输入感兴趣的主题">
          </div>
        </div>
      </div>
    </fill-modal>

    <div class="pop-success pop-profile" v-if="isConfirm">
      <div class="pop-inner">
        <img src="~@static/fundingnew/profile/pop-text-finish.png" class="txt">
        <div class="btn-submit" @click="bindToConfirm">知道啦</div>
      </div>
    </div>
  </div>
</template>

<script>
import PageFooter from '@components/PageFooter'
import FillModal from '../components/FillModal'
import { mapState, mapMutations } from 'vuex'
import cityJs from '@javascripts/cities.js'
import { verify, tools } from '@/utils'
import { behavior } from '@/utils/behavior'
import VueCoreImageUpload from 'vue-core-image-upload'

export default {
  name: 'ProfileFill',
  components: {
    PageFooter,
    FillModal,
    VueCoreImageUpload,
  },
  data() {
    return {
      isShow: false,
      selectType: 0,
      selectHobby: [],
      selectTopic: [],
      hobbyData: [
        { id: 1, name: '涂鸦', checked: false },
        { id: 2, name: '品酒', checked: false },
        { id: 3, name: '蹦迪', checked: false },
        { id: 4, name: '弹吉他', checked: false },
        { id: 5, name: '听音乐', checked: false },
        { id: 6, name: '健身', checked: false },
        { id: 7, name: '摄影', checked: false },
        { id: 8, name: '冲浪', checked: false },
        {
          id: 12,
          name: '',
          checked: false,
        },
      ],
      topicData: [
        {
          id: 1,
          name: '野生朋克',
          checked: false,
        },
        {
          id: 2,
          name: '摩登复古',
          checked: false,
        },
        {
          id: 3,
          name: '灵感先锋',
          checked: false,
        },
        {
          id: 4,
          name: '涂鸦青年',
          checked: false,
        },
        {
          id: 5,
          name: '电子摇滚',
          checked: false,
        },
        {
          id: 6,
          name: 'TRAP',
          checked: false,
        },
        {
          id: 7,
          name: '蒸汽波',
          checked: false,
        },
        {
          id: 8,
          name: 'EDM',
          checked: false,
        },
        {
          id: 9,
          name: '朋克',
          checked: false,
        },
        {
          id: 10,
          name: 'HIPHOP',
          checked: false,
        },
        {
          id: 11,
          name: 'LO-FI',
          checked: false,
        },
        {
          id: 12,
          name: '',
          checked: false,
        },
      ],
      genderData: [
        {
          id: 1,
          name: '男生',
          ImgUrl: require('@static/fundingnew/profile/icon-male.png'),
          ImgUrlActive: require('@static/fundingnew/profile/icon-male-selected.png'),
        },
        {
          id: 2,
          name: '女生',
          ImgUrl: require('@static/fundingnew/profile/icon-female.png'),
          ImgUrlActive: require('@static/fundingnew/profile/icon-female-selected.png'),
        },
        {
          id: 3,
          name: '保密',
          ImgUrl: require('@static/fundingnew/profile/icon-gender.png'),
          ImgUrlActive: require('@static/fundingnew/profile/icon-gender-selected.png'),
        },
      ],
      minDate: new Date(1920, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      cusHobbyVal: '',
      cusTopicVal: '',
      columns: [],
      headimgurl: '',
      nickname: '',
      user_birthday: '',
      selectBirthday: '',
      user_gender: 0,
      selectGender: 0,
      user_hobby: '',
      user_city: '',
      selectCity: '',
      user_province: '',
      selectProvince: '',
      user_topic: '',
      isConfirm: false,
      // 来源
      profile_from: '',
      hostUrl: this.$apiConfig.host,
      uploadUrl: this.$apiConfig.uploadUrl,
      // nick修改
      isNameFocus: false,
    }
  },
  computed: {
    pickerItemHeight() {
      return '29px'
    },
    genderName() {
      return this.user_gender == 1 ? '男生' : this.user_gender == 2 ? '女生' : this.user_gender == 3 ? '保密' : ''
    },
    topicName() {
      return this.selectTopic
        .filter(item => item.checked)
        .map(item => item.name)
        .join('/')
    },
    hobbyName() {
      return this.selectHobby
        .filter(item => item.checked)
        .map(item => item.name)
        .join('/')
    },
  },
  created(opts) {
    const { profile_from } = this.$route.query
    this.profile_from = profile_from
    this.getProfile()
  },
  mounted() {
    this.setProfileVisitCount(3)
    //city
    let mapData = []
    cityJs.citiesData.provinces.forEach(item => {
      let obj = {
        text: item.provinceName,
        children: item.citys.map(item2 => {
          return {
            text: item2.citysName,
          }
        }),
      }
      mapData.push(obj)
    })
    this.columns = mapData

    // 分享
    if (verify.isWeixin()) {
      let shareInfo = {
        title: '绝对夜计划',
        desc: '绝对赛博夜计划，最高赢取5万元派对金，邀你一起造',
        imgUrl: this.$apiConfig.domain + '/static/funding_cpunk/share.png?v=1',
      }
      let p = tools.parseParams(this.$route.query)
      this.WXConfig.wxShowMenu(`${this.$apiConfig.domain}/welcome?${p}`, shareInfo)
    }
  },
  methods: {
    ...mapMutations(['setProfileVisitCount']),
    complete() {
      this.isConfirm = true
      if (this.profile_from === 'center') {
        _jcq.push(['_track', 'personalfinish_click'])
        behavior({ behavior_code: 'prc_bhv_abs_personalcenter_bc2' })
      }
      if (this.profile_from === 'creation') {
        _jcq.push(['_track', 'yjhbcpersonalfinish_click'])
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc31' })
      }
      if (this.profile_from === 'calendar') {
      }
    },
    getProfile: function () {
      this.$request
        .get(this.$apiConfig.myProfile)
        .then(res => {
          const resData = res.data
          if (resData.code == 0 && resData.data) {
            let d = resData.data
            const { headimgurl, nickname, user_city, user_birthday, user_gender, user_hobby, user_province, user_topic } = d
            this.headimgurl = headimgurl
            this.nickname = nickname

            this.user_birthday = this.selectBirthday = user_birthday
            this.currentDate = user_birthday ? new Date(user_birthday) : new Date('2000-01-01')
            this.user_gender = this.selectGender = user_gender
            this.user_city = this.selectCity = user_city
            this.user_province = this.selectProvince = user_province
            this.user_topic = user_topic
            this.setTopic()
            this.user_hobby = user_hobby
            this.setHobby()
          } else {
            console.log(res.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    setTopic() {
      let topic = this.user_topic.split(';')
      this.selectTopic = JSON.parse(JSON.stringify(this.topicData))
      //  "topic": "1:野生朋克;2:EDM;3:灵感先锋"
      topic.forEach(item => {
        if (item === '') {
          return
        }
        let m = item.split(/,|:/)
        let j = this.selectTopic.find(i => {
          return i.id == m[0]
        })
        j.checked = true
        if (m[0] == 12) {
          j.name = m[1]
          this.cusTopicVal = m[1]
        }
      })
    },
    setHobby() {
      let hobby = this.user_hobby.split(';')
      this.selectHobby = JSON.parse(JSON.stringify(this.hobbyData))
      //  "hobby": "1:野生朋克;2:EDM;3:灵感先锋"
      hobby.forEach(item => {
        if (item === '') {
          return
        }
        let m = item.split(/,|:/)
        let j = this.selectHobby.find(i => {
          return i.id == m[0]
        })
        j.checked = true
        if (m[0] == 12) {
          j.name = m[1]
          this.cusHobbyVal = m[1]
        }
      })
    },
    handleClickItem(type) {
      this.selectType = type
      this.isShow = true
      if (type == 3) {
        this.$nextTick(() => {
          this.setCityIdx()
        })
      }
    },
    setCityIdx() {
      if (this.user_province) {
        let obj = cityJs.citiesData.provinces
        let i1 = obj.findIndex(item => {
          return item.provinceName === this.user_province
        })
        if (i1 === -1) {
          this.$refs.cityPicker.setIndexes([0, 0])
          return
        }
        let i2 = obj[i1].citys.findIndex(item => {
          return item.citysName === this.user_city
        })
        this.$refs.cityPicker.setIndexes([i1, i2])
      } else {
        this.$refs.cityPicker.setIndexes([0, 0])
      }
    },
    handleSelectGender(id) {
      this.selectGender = id
    },
    handleSelectHobbie(index) {
      this.selectHobby[index].checked = !this.selectHobby[index].checked
    },
    handleSelectTopic(index) {
      this.selectTopic[index].checked = !this.selectTopic[index].checked
    },
    handleChange(picker) {
      const formatValue = picker.getValues()[0] + picker.getValues()[1] + picker.getValues()[2]
      const format = (picker.getValues()[0] + picker.getValues()[1] + picker.getValues()[2]).replace(/[\u4e00-\u9fa5]/g, '-')
      this.selectBirthday = format.slice(0, -1)
    },
    handleCityChange(picker, value, index) {
      this.selectProvince = value[0]
      this.selectCity = value[1]
    },
    fillModalCancel() {
      if (this.selectType == 1) {
        this.selectGender = this.user_gender
      } else if (this.selectType == 2) {
        this.currentDate = new Date(this.user_birthday || '2000-01-01')
      } else if (this.selectType == 3) {
        this.selectCity = this.user_city
        this.selectProvince = this.user_province
      } else if (this.selectType == 4) {
        this.setHobby()
      } else if (this.selectType == 5) {
        this.setTopic()
      }
    },
    fillModalConfirm() {
      if (this.selectType == 1) {
        this.updateGender()
      } else if (this.selectType == 2) {
        this.updateBirthday()
      } else if (this.selectType == 3) {
        this.updateCity()
      } else if (this.selectType == 4) {
        this.updateHobby()
      } else if (this.selectType == 5) {
        this.updateTopic()
      }
    },
    // 性别
    updateGender() {
      const _self = this
      this.$request
        .post(this.$apiConfig.updateGender, {
          gender: this.selectGender,
        })
        .then(res => {
          const resData = res.data
          if (resData.code == 0) {
            this.user_gender = this.selectGender = resData.data.gender
          } else {
            alert(resData.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    // 生日
    updateBirthday() {
      let D = tools.formatDate(Date.now() / 1000)
      this.$request
        .post(this.$apiConfig.updateBirthday, {
          birthday: this.selectBirthday || `${D.year}-${D.month}-${D.day}`,
        })
        .then(res => {
          const resData = res.data
          if (resData.code == 0) {
            this.user_birthday = this.selectBirthday = resData.data.birthday
          } else {
            alert(resData.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    // 城市
    updateCity() {
      const _self = this
      this.$request
        .post(this.$apiConfig.updateCity, {
          city: this.selectCity,
          province: this.selectProvince,
        })
        .then(res => {
          const resData = res.data
          if (resData.code == 0) {
            this.user_city = this.selectCity = resData.data.city
            this.user_province = this.selectProvince = resData.data.province
          } else {
            alert(resData.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    // 主题
    updateTopic() {
      let cusToptic = this.selectTopic.find(i => i.id === 12)
      // 自定义字段
      if (this.cusTopicVal != '') {
        cusToptic.checked = true
        cusToptic.name = this.cusTopicVal
      } else {
        cusToptic.checked = false
        cusToptic.name = ''
      }
      // 传参
      let IDS = this.selectTopic
        .filter(item => item.checked)
        .map(item => `${item.id},${item.name}`)
        .join(';')
      // post
      if (IDS === '') {
        this.fillModalCancel()
        return
      }
      this.$request
        .post(this.$apiConfig.updateTopic, {
          topic: IDS,
        })
        .then(res => {
          const resData = res.data
          if (resData.code == 0) {
            this.user_topic = resData.data.topic
            this.setTopic()
          } else {
            alert(resData.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    // 爱好
    updateHobby() {
      let cusHobby = this.selectHobby.find(i => i.id === 12)
      // 自定义字段
      if (this.cusHobbyVal != '') {
        cusHobby.checked = true
        cusHobby.name = this.cusHobbyVal
      } else {
        cusHobby.checked = false
        cusHobby.name = ''
      }
      // 传参
      let IDS = this.selectHobby
        .filter(item => item.checked)
        .map(item => `${item.id},${item.name}`)
        .join(';')
      // post
      if (IDS === '') {
        this.fillModalCancel()
        return
      }
      this.$request
        .post(this.$apiConfig.updateHobby, {
          hobby: IDS,
        })
        .then(res => {
          const resData = res.data
          if (resData.code == 0) {
            this.user_hobby = resData.data.hobby
            this.setTopic()
          } else {
            alert(resData.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    formatter(type, val) {
      if (type === 'year') {
        return val + '年'
      }
      if (type === 'month') {
        return val + '月'
      }
      if (type === 'day') {
        return val + '日'
      }
      return val
    },
    bindToConfirm() {
      this.isConfirm = false
      this.$router.go(-1)
    },
    imageuploaded(res) {
      if (res.code == 0) {
        let data = res.data
        let img_src = data.base
        this.$request
          .post(this.$apiConfig.myAvatarUrl, {
            avatar: img_src,
          })
          .then(res => {
            const resData = res.data
            if (resData.code == 0 && resData.data) {
              let d = resData.data
              this.headimgurl = this.hostUrl + d.avatar
              _jcq.push(['_track', 'myhead_click'])
              behavior({ behavior_code: 'prc_bhv_abs_personalcenter_bc10' })
            } else {
              alert(resData.msg)
            }
          })
          .catch(e => {
            console.log(e)
          })
      } else {
        alert('上传失败')
      }
    },
    imageuploading() {},
    bindEditName() {
      this.isNameFocus = true
      _jcq.push(['_track', 'myname_click'])
      behavior({ behavior_code: 'prc_bhv_abs_personalcenter_bc11' })
    },

    bindNicknameConfirm: function (e) {
      let _this = this
      this.$request
        .post(this.$apiConfig.myNicknameUrl, {
          nickname: e.currentTarget.value,
        })
        .then(res => {
          const resData = res.data
          if (resData.code == 0 && resData.data) {
            this.isNameFocus = false
            this.nickname = e.currentTarget.value
          } else {
            console.log(res.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/v2-common.scss';

.profile-wrap {
  position: relative;
  padding-top: pxtow(100);
  .user-avatar {
    position: relative;
    width: pxtow(200);
    height: pxtow(200);
    margin: 0 auto;
    border-radius: 50%;
    .img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .nick-name {
    position: relative;
    font-size: pxtow(36);
    font-weight: bold;
    font-family: 'Absolut-Bold';
    color: #fff;
    margin-top: pxtow(42);
    text-align: center;
    span {
      vertical-align: middle;
      margin-top: 5px;
      display: inline-block;
    }
    input {
      font-size: inherit;
      text-align: center;
      width: 100%;
      vertical-align: middle;
      background: transparent;
      border: 0;
    }
    .icon-edit {
      width: pxtow(38);
      object-fit: contain;
    }
  }

  .btn-submit {
    position: fixed;
    left: 0;
    bottom: pxtow(100);
    @include respond-to(iphonex) {
      bottom: pxtow(270);
    }
    text-align: center;
    width: 100%;
  }
}

.fill-cells {
  padding-top: pxtow(22);
  .fill-cell-item {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: pxtow(550);
    margin: pxtow(22) auto 0;
    height: pxtow(55);
    background-image: url('~@static/fundingnew/profile/sm-btn-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    font-size: pxtow(24);
    font-family: 'Absolut-Bold';
    font-weight: bold;
    color: #fff;
    text-align: center;
    padding-right: pxtow(36);
    padding-left: pxtow(36);
    div {
      @include no-break-line;
    }
    &::after {
      content: '';
      position: absolute;
      right: pxtow(21);
      top: 50%;
      transform: translateY(-50%);
      width: pxtow(10);
      height: pxtow(19);
      background-image: url('~@static/fundingnew/profile/icon-sm-btn-arrow.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
}

.modal-title {
  font-size: pxtow(24);
  color: #fff;
  text-align: center;
  margin-top: pxtow(50);
}
.sex-picker {
  display: flex;
  padding: pxtow(26) 0 pxtow(50);
  .sex-picker-item {
    flex: 1;
    justify-content: center;
    .img-inner {
      position: relative;
      width: pxtow(147);
      height: pxtow(147);
      margin: 0 auto;
    }
    .img {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      max-width: 100%;
      max-height: 100%;
    }
    .sex-picker-name {
      font-size: pxtow(24);
      color: #fff;
      text-align: center;
      margin-top: pxtow(26);
      color: #a92198;
      &.active {
        color: #fff;
      }
    }
  }
}
%sm-ball {
  font-size: pxtow(24);
  font-family: 'Absolut-Bold';
  width: pxtow(126);
  height: pxtow(126);
  white-space: nowrap;
}
%lg-ball {
  font-size: pxtow(50);
  font-family: 'Absolut-Bold';
  width: pxtow(250);
  height: pxtow(250);
  white-space: nowrap;
}

@keyframes move1 {
  0% {
    transform: translate(-2%, -2%);
  }
  100% {
    transform: translate(2%, 2%);
  }
}
@keyframes move2 {
  0% {
    transform: translate(2%, 2%);
  }
  100% {
    transform: translate(-2%, -2%);
  }
}

@keyframes twinkling {
  0% {
    -webkit-transform: scale(1);
  }
  50% {
    -webkit-transform: scale(0.95);
  }
  100% {
    -webkit-transform: scale(1);
  }
}

.circle-list {
  position: relative;
  height: pxtow(676);
  .circle-item {
    position: absolute;
    color: #a92198;
    background-image: url('~@static/fundingnew/profile/big-circle.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    animation: move1 2s linear infinite alternate;
    &.active {
      color: #fff;
      background-image: url('~@static/fundingnew/profile/big-circle-selected.png');
    }
    .circle-item-name {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &:nth-child(2n) {
      animation: move2 2s linear infinite alternate;
    }
    &:nth-child(1) {
      @extend %lg-ball;
      top: pxtow(46);
      left: pxtow(183);
    }
    &:nth-child(2) {
      @extend %lg-ball;
      top: pxtow(255);
      left: pxtow(346);
    }
    &:nth-child(3) {
      @extend %lg-ball;
      top: pxtow(426);
      left: pxtow(100);
    }
    &:nth-child(4) {
      @extend %lg-ball;
      top: pxtow(98);
      left: pxtow(576);
    }
    &:nth-child(5) {
      @extend %lg-ball;
      top: pxtow(193);
      left: pxtow(-98);
    }
    &:nth-child(6) {
      @extend %sm-ball;
      top: pxtow(70);
      left: pxtow(42);
    }
    &:nth-child(7) {
      @extend %sm-ball;
      top: pxtow(118);
      left: pxtow(443);
    }
    &:nth-child(8) {
      @extend %sm-ball;
      top: pxtow(289);
      left: pxtow(160);
    }
    &:nth-child(9) {
      @extend %sm-ball;
      top: pxtow(375);
      left: pxtow(604);
    }
    &:nth-child(10) {
      @extend %sm-ball;
      top: pxtow(485);
      left: pxtow(512);
    }
    &:nth-child(11) {
      @extend %sm-ball;
      top: pxtow(512);
      left: pxtow(370);
    }
    &:nth-child(12) {
      display: none;
    }
  }
}

.profile-hobbies .circle-list .circle-item {
  &:nth-child(4) {
    @extend %sm-ball;
    top: pxtow(375);
    left: pxtow(604);
  }
  &:nth-child(5) {
    @extend %sm-ball;
    top: pxtow(485);
    left: pxtow(512);
  }
  &:nth-child(9) {
    display: none;
  }
}
.user-input {
  padding-top: pxtow(50);
  padding-bottom: pxtow(100);
  .user-input-inner {
    margin: 0 auto;
    width: pxtow(550);
    height: pxtow(55);
    text-align: center;
    background-image: url('~@static/fundingnew/profile/input-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .user-input-control {
      background: transparent;
      width: 100%;
      height: inherit;
      border: 0;
      outline: none;
      font-size: pxtow(24);
      color: #fff;
      font-family: 'Absolut-Bold';
      font-weight: bold;
      text-align: center;
      &::placeholder {
        color: #fff;
      }
    }
  }
}
.pop-profile {
  .pop-inner {
    img {
      width: pxtow(260);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/my/Profile.vue